import React, { useRef } from 'react';
import { toast } from 'react-toastify';
import { useProject } from '../context';
import { updateProject } from '../../../../../services/projectService';

const ProjectName = () => {
  const { projectDetails, refetchProject, setProjectDetails, isEditPermission } = useProject();
  const projectName = projectDetails?.projectName;
  const nameRef = useRef(null);

  const handleBlur = async (e) => {
    const name = e?.target?.innerText?.trim();
    if (!isEditPermission || !name.length > 0 || name === projectName) return;
    try {
      await updateProject(projectDetails?.id, { projectName: name });
      setProjectDetails((prev) => ({ ...prev, projectName: name }));
    } catch (error) {
      const errMsg =
        error?.response?.data?.message || 'An error occurred while saving the project name. Please try again later.';
      toast.error(errMsg);
      refetchProject();
    }
  };

  const handleKeyDown = (event) => {
    if (event.keyCode === 13) {
      nameRef.current.blur();
    }
  };

  if (!projectName) return null;
  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <span
      style={{ textTransform: 'capitalize' }}
      ref={nameRef}
      contentEditable={isEditPermission}
      onBlur={handleBlur}
      onKeyDown={handleKeyDown}
    >
      {projectName}
    </span>
  );
};

export default ProjectName;
